import { Stack, TextField, Typography } from "@mui/material";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import React from "react";
import paginationStyles from "./Pagination.module.css";

interface PaginationProps {
  rows: string;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  totalDataLength: number;
  dataPerPage: number;
}

const Pagination: React.FC<PaginationProps> = (props) => {
  const handlePreviousPage = () => {
    if (props.currentPage > 1) props.setCurrentPage((prevPage) => prevPage - 1);
  };

  if (props.totalDataLength === 0) {
    props.setCurrentPage(0);
  }

  const handlePaginationPageNumber = (event: any) => {
    const inputPageNumber = Number(event.target.value);
    if (
      inputPageNumber <= Math.ceil(props.totalDataLength / props.dataPerPage)
    ) {
      props.setCurrentPage(Math.ceil(inputPageNumber));
    }
  };

  const handleNextPage = () => {
    const totalPages = Math.ceil(props.totalDataLength / props.dataPerPage);
    if (props.currentPage < totalPages)
      props.setCurrentPage((prevPage) => prevPage + 1);
  };
  return (
    <Stack
      direction="row"
      spacing={2}
      className={paginationStyles.paginationOuterStack}
    >
      <KeyboardDoubleArrowLeftIcon
        className={
          props.currentPage > 1
            ? paginationStyles.paginationEnable
            : paginationStyles.paginationDisable
        }
        onClick={() => props.setCurrentPage(1)}
      />

      <ChevronLeftOutlinedIcon
        className={
          props.currentPage > 1
            ? paginationStyles.paginationEnable
            : paginationStyles.paginationDisable
        }
        onClick={handlePreviousPage}
      />

      <TextField
        className={paginationStyles.paginationTextFieldCss}
        variant="standard"
        inputProps={{ min: 0, style: { textAlign: "center" } }}
        value={String(props.currentPage)}
        onChange={(event) => {
          handlePaginationPageNumber(event);
        }}
        type="number"
      />
      <Typography>
        of &ensp; {Math.ceil(props.totalDataLength / props.dataPerPage)}
      </Typography>
      <ChevronRightOutlinedIcon
        className={
          props.currentPage < props.totalDataLength / props.dataPerPage
            ? paginationStyles.paginationEnable
            : paginationStyles.paginationDisable
        }
        onClick={handleNextPage}
      />
      <KeyboardDoubleArrowRightIcon
        className={
          props.currentPage < props.totalDataLength / props.dataPerPage
            ? paginationStyles.paginationEnable
            : paginationStyles.paginationDisable
        }
        onClick={() => {
          props.setCurrentPage(
            Math.ceil(props.totalDataLength / props.dataPerPage)
          );
        }}
      />
    </Stack>
  );
};

export default Pagination;
